import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";

import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';
import { Compania } from '../Models/Compania';
import { TryCatchStmt } from '@angular/compiler';
import { Vehiculo } from '../Models/Vehiculo';

@Injectable()
export class VehiculoService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }


  /**
   * Obtengo la informacion del vehiculo espesifico
   * @param compania Codigo de la compañia
   * @param idVehiculo Codigo del vehiculo (placa)
   */
  ObtenerVehiculo(compania: string, idVehiculo: string): Observable<Vehiculo> {

    try {

      let url = this._utiles.getURL("vehiculo/" + compania + '/' + idVehiculo);


      return this._http.get(url).map((response: Response) => {
        return <Vehiculo>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


  /**
   * Obtengo todos los vehiculos de la compañia
   * @param compania Codigo de la compañia
   */
  ObtenerVehiculos(compania: string): Observable<Vehiculo[]> {

    try {

      let url = this._utiles.getURL("vehiculo/" + compania);


      return this._http.get(url).map((response: Response) => {
        return <Vehiculo[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }

  /**
   * Guarda el registro del vehiculo
   * @param vehiculo Objeto de tipo "Vehiculo"
   */
  public GuardarRegistro(vehiculo: Vehiculo) {

    try {

      let params = JSON.stringify(vehiculo);

      let url = this._utiles.getURL("vehiculo/");

      let headers = new Headers({ 'Content-Type': 'application/json' });


      let data: any;

      return this._http.post(url, vehiculo, {headers: headers}).map(res => res.json());

    } catch (error) {
      console.log(error);
    }


  }

}
